// import 'core-js/stable';
// optional but required for transforming generator fns.
// import 'regenerator-runtime/runtime';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/plugins/vue-material'
import '@/plugins/vuelidate'
import '@/plugins/vue-socket'
import '@/plugins/vue-toast'

import './registerServiceWorker'
import './services/axios-handler'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
